//

import $ from "jquery";
import B2bEvent from "./B2bEvent";
import { Echangeur } from "./Echangeur";
import hash from "./hash";
import MiniFormulaire from "./MiniFormulaire";
import notesVersion from "./views/components/notesVersion";
import alertesATraiter from "./views/components/alertesATraiter";
import { arreteDirect, demarreDirect } from "./tools/direct";
//
// Variable globale
const formulaire = {}; // liste des formulaires existants

const CTX = {
  session: null,
  sidebar: null,
  disableOnHashChange: false,
};
B2bEvent.set("CTX", CTX);

// Routes réservées aux administrateurs et concepteurs (C/A)
const ROUTES_ADMIN_ONLY = ["logsImports", "systemeInfos", "depots", "fonctionnement", "activite"];
// Routes réservées aux administrateurs, concepteurs, ou utilisateurs avec le droit menuadm
const ROUTES_ADMIN_OR_MENUADM = ["users", "userDetail"];

function isRouteAllowed(routeName) {
  if (!CTX.session) return false;
  const role = CTX.session.role;
  const isAdminOrConcepteur = role === "C" || role === "A";

  if (ROUTES_ADMIN_ONLY.includes(routeName)) return isAdminOrConcepteur;
  if (ROUTES_ADMIN_OR_MENUADM.includes(routeName))
    return isAdminOrConcepteur;
  return true;
}

async function onHashChange() {
  //
  if (CTX.disableOnHashChange) return;
  //
  var array = hash.toArray();
  //
  const hash0 = array.length ? array[0] : {};
  //
  if (!hash0.hash) {
    window.location.hash = "#start";
    return;
  } else if (hash0.hash == "logout") {
    //
    CTX.session = null;
    CTX.disableOnHashChange = true;
    notesVersion.demarre(null);
    alertesATraiter.demarre(null);
    arreteDirect();
    $("#topbar").empty();
    await Echangeur.logout();
    //
    //
    window.location.hash = "";
    await demarrageClientSession();
    //
    return;
  }
  //
  var last = array[array.length - 1];
  var index = array.length;
  //
  if (!isRouteAllowed(last.hash)) {
    window.location.hash = "#start";
    return;
  }
  //
  if (index > 1) {
    hash.ecrans[index - 1].sauve();
  }
  //
  $("#hash0").hide();
  //
  for (let i = 0; i < hash.ecrans.length; i++) {
    if (i <= index) hash.ecrans[i].hide(); // Masque tous les écrans précédent  l'écran en cours
    if (i > index) hash.ecrans[i].purge(); // Purge  tous les écrans après l'écrans au dessus
  }
  var ecran = hash.ecrans[index];
  //
  if (
    ecran &&
    ecran.mf &&
    ecran.mf.cacheHash &&
    ecran.mf.cacheHash == last.hash &&
    ecran.mf.reprise
  ) {
    const x = new Echangeur();
    x.hash = last.par;
    ecran.mf.reprise(ecran, x);
  } else {
    if (!formulaire[last.hash]) throw "Formulaire inexistant : " + last.hash;
    //

    ecran.mf = new MiniFormulaire();
    ecran.mf.initialise("#" + ecran.id);
    ecran.mf.fillImport(formulaire[last.hash]);
    const x = new Echangeur("getForm_" + last.hash);
    x.hash = last.par;
    await ecran.mf.demarre(last.par, hash.fin, x);
    ecran.mf.cacheHash = last.hash;
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  demarrageClient();
});

async function demarrageClient() {
  const addToFormulaire = function (u) {
    for (var i in u.default) formulaire[i] = u.default[i];
  };
  // Écrans téléchargés en parallèle (et non plus l'un après l'autre), puis enregistrés dans le même ordre
  const ecrans = await Promise.all([
    import("./views/start"),
    import("./views/nouveautes"),
    //
    import("./views/order/ordersToAssign"),
    import("./views/order/ordersToAssignDetail"),
    import("./views/order/ordersSearch"),
    import("./views/order/ordersSearchDetail"),
    //
    import("./views/auth/signin"),
    //
    import("./views/sidebar"),

    import("./views/user/users"),
    import("./views/user/userDetail"),

    import("./views/admin/logsImports"),
    import("./views/admin/importsStats"),

    import("./views/admin/systemeInfos"),
    import("./views/admin/depots"),
    import("./views/admin/activite"),
    import("./views/admin/fonctionnement"),
  ]);
  ecrans.forEach(addToFormulaire);

  //
  await demarrageClientSession();
}

async function demarrageClientSession() {
  while (CTX.session == null) {
    try {
      CTX.session = await Echangeur.restnomodal("sessionInit"); //on verifie si on est authentifié
    } catch (e) {
      CTX.session = null;
    }
    if (!CTX.session) {
      await demarrageClientSignin();
    }
  }
  await demarrageClientSuite();
}

function demarrageClientSignin() {
  // Lancement du formulaire de login
  return new Promise(function (resolve, reject) {
    var mf = new MiniFormulaire("login");
    mf.initialise("#hash0");
    mf.fillImport(formulaire.signin);
    //
    mf.demarre({}, function () {
      // fonction fin du miniformulaire
      resolve();
    });
  });
}

window.onError401 = function () {
  return new Promise(function (resolve, reject) {
    location.reload();
  });
};

// Ici, on est authentifié
async function demarrageClientSuite() {
  $("#sidebar").empty();
  $("#topbar").empty();
  //
  CTX.sidebar = new MiniFormulaire("sidebar");
  CTX.sidebar.initialise("#sidebar");
  CTX.sidebar.fillImport(formulaire.sidebar);
  await CTX.sidebar.demarre(CTX.session);
  //
  notesVersion.demarre(CTX.session);
  alertesATraiter.demarre(CTX.session);
  // Présence en ligne et journal en direct (page #activite)
  demarreDirect();
  //
  CTX.disableOnHashChange = false;
  window.onhashchange = onHashChange;
  onHashChange();
}

export default {};
